import React, { useState } from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { OrderSide } from 'opensea-js/lib/types';
import BigNumber from 'bignumber.js';
import ContentLoader from "react-content-loader";
import { Link, useParams, useHistory } from "react-router-dom";

function toUnitAmount(baseAmount, tokenContract = null) {
  const decimals = tokenContract && tokenContract.decimals != null
    ? tokenContract.decimals
    : 18

  const amountBN = new BigNumber(baseAmount.toString())
  return amountBN.div(new BigNumber(10).pow(decimals))
}

const NftMarketplace = ({seaport}) => {
  const params = useParams();
  const history = useHistory();
  const { slug } = params;
  const [orders, setOrders] = useState([]);
  const [collectionName, setCollectionName] = useState(null);
  const [collectionSlug, setCollectionSlug] = useState(slug || null);
  const [page, setPage] = useState(1);
  const [isContentLoading, setIsContentLoading] = useState(true);
  const pageStart = page-page%10;
  const pages = page%10 == 0 ? [-5,-4,-3,-2,-1,0,1,2,3,4].map(x => x + pageStart) : [1,2,3,4,5,6,7,8,9,10].map(x => x + pageStart);

  async function fetchOrders(collectionSlug, pageNum = 1) {
    setIsContentLoading(true);

    if(!collectionSlug) {
      // const { orders } = await seaport.api.getOrders({
      //   side: OrderSide.Sell
      // }, pageNum);

      const { assets } = await seaport.api.getAssets({
        limit: 20
      }, pageNum);

      const orders = assets.map(x => ({asset: x}));

      setOrders(orders);
      setIsContentLoading(false);
    } else {
      const { assets } = await seaport.api.getAssets({
        collection: collectionSlug,
        limit: 20
      }, pageNum);
      // const assetContractAddress = assets[0].tokenAddress;
      // const tokenIds = assets.map(x => x.tokenId);
      // const { orders } = await seaport.api.getOrders({
      //   limit: 20,
      //   side: OrderSide.Sell,
      //   asset_contract_address: assetContractAddress,
      //   token_ids: tokenIds
      // });
      const orders = assets.map(x => ({asset: x}));
      setOrders(orders);
      if(orders.length > 0) {
        setCollectionName(orders[0].asset.collection.name);
      }
      setIsContentLoading(false);
    }
  }

  async function paginateTo(pageNum) {
    setOrders([]);
    setPage(pageNum);
    await fetchOrders(collectionSlug, pageNum);
  }

  async function filterCollection(slug, name) {
    setIsContentLoading(true);
    setCollectionName(name);
    setCollectionSlug(slug);
    setPage(1);
    history.push('/nft/' + slug);
    await fetchOrders(slug, 1);
  }

  async function resetFilterCollection() {
    setIsContentLoading(true);
    setCollectionName(null);
    setCollectionSlug(null);
    setPage(1);
    history.push('/nft');
    await fetchOrders(null, 1);
  }

  React.useEffect(() => {
    fetchOrders(collectionSlug);
  }, []);

  return (
    <>
      <div className="nft-collections">
        {!collectionName && isContentLoading &&
          <ContentLoader 
            speed={2}
            width={300}
            height={300}
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            style={{maxWidth: '100%'}}
          >
            <rect x="0" y="0" rx="2" ry="2" width="150" height="18" />
            <rect x="0" y="30" rx="2" ry="2" width="200" height="18" />
            <rect x="0" y="60" rx="2" ry="2" width="100" height="18" />
            <rect x="0" y="90" rx="2" ry="2" width="250" height="18" />    
            <rect x="0" y="120" rx="2" ry="2" width="150" height="18" />
            <rect x="0" y="150" rx="2" ry="2" width="200" height="18" />
            <rect x="0" y="180" rx="2" ry="2" width="100" height="18" />
            <rect x="0" y="210" rx="2" ry="2" width="250" height="18" />       
          </ContentLoader>
        }
        {!collectionName && !isContentLoading && [...new Set(orders.filter(x => x.asset != null).map(x => JSON.stringify({name: x.asset.collection.name, slug: x.asset.collection.slug})))].map(JSON.parse).map(x => <span onClick={() => filterCollection(x.slug, x.name)} key={x.slug}>{x.name}</span>)}
        {collectionName && <span key={collectionSlug} onClick={() => resetFilterCollection()}>{collectionName}</span>}
      </div>
      <div className="nft-gallery">
        {isContentLoading && Array.from(Array(20).keys()).map(x => {
          return (
            <div className="nft-preview" key={x}>
              <ContentLoader 
                speed={2}
                width={200}
                height={320}
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
                style={{maxWidth: '100%'}}
              >
                <rect x="0" y="0" rx="2" ry="2" width="200" height="200" />
                <rect x="0" y="215" rx="2" ry="2" width="150" height="18" />
                <rect x="0" y="240" rx="2" ry="2" width="200" height="18" />
                <rect x="0" y="265" rx="2" ry="2" width="100" height="18" />
              </ContentLoader>
            </div>
          );
        })}
        { !isContentLoading && 
          orders.map(o => {
            if(!o.asset || o.asset.imagePreviewUrl == null) {
              return null;
            }

            // const isETH = o.paymentTokenContract.symbol === "ETH";
            // const price = parseFloat(toUnitAmount(o.currentPrice, o.paymentTokenContract)).toLocaleString(undefined, { minimumSignificantDigits: 1 });

            return (
              <div className="nft-preview" key={o.hash}>
                <div className="thumbnail"><Link to={`/nft/${o.asset.tokenAddress}/${o.asset.tokenId}`}><img src={o.asset.imagePreviewUrl} /></Link></div>
                <h3 onClick={() => filterCollection(o.asset.collection.slug, o.asset.collection.name)}>{o.asset.collection.name}</h3>
                <h4><Link to={`/nft/${o.asset.tokenAddress}/${o.asset.tokenId}`}>{o.asset.name || o.asset.tokenId}</Link></h4>
                {/* <h5>{isETH ? 'Ξ' : null}{price} {isETH ? null : o.paymentTokenContract.symbol}</h5> */}
              </div>
            )
          })
        }
      </div>
      { orders.length < 20 ||
        <>
          <Pagination className="nft-pagination" aria-label="Page navigation">
            <PaginationItem disabled={page === 1} onClick={() => page !== 1 ? paginateTo(1) : null}>
              <PaginationLink first href="#" />
            </PaginationItem>
            <PaginationItem disabled={page === 1} onClick={() => page !== 1 ? paginateTo(page - 1) : null}>
              <PaginationLink previous href="#" />
            </PaginationItem>
            {pages.map(x => (
              <PaginationItem active={x === page} onClick={() => paginateTo(x)} key={x}>
                <PaginationLink href="#">
                  {x}
                </PaginationLink>
              </PaginationItem>
            ))}
            <PaginationItem onClick={() => paginateTo(page+1)}>
              <PaginationLink next href="#">Next ›</PaginationLink>
            </PaginationItem>
          </Pagination>
          <Pagination className="nft-pagination mobile" aria-label="Page navigation">
            <PaginationItem disabled={page === 1} onClick={() => page !== 1 ? paginateTo(page - 1) : null}>
              <PaginationLink previous href="#">‹ Previous</PaginationLink>
            </PaginationItem>
            <PaginationItem onClick={() => paginateTo(page+1)}>
              <PaginationLink next href="#">Next ›</PaginationLink>
            </PaginationItem>
          </Pagination>
        </>
      }
    </>
  );
};

export default NftMarketplace;
